export default "../images/bvm-logo.svg";